import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, changeLanguage, toSupportedLanguage } from '@/i18n';
import { cn } from '@/lib/utils';

/**
 * Sélecteur de langue discret. Partagé par la barre latérale et les pages
 * publiques (portails transporteur, connexion…) : sans lui, un transporteur
 * étranger qui ouvre un lien reçu par e-mail n'avait aucun moyen de changer de
 * langue. Charge le dictionnaire avant de basculer.
 */
export function LanguageSelect({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  return (
    <select
      value={toSupportedLanguage(i18n.language)}
      onChange={(e) => void changeLanguage(e.target.value)}
      aria-label={t('nav.language')}
      className={cn(
        'cursor-pointer appearance-none rounded border-0 bg-transparent py-1 pr-1 text-2xs font-medium text-subtle hover:text-text focus:outline-none focus:ring-1 focus:ring-accent',
        className,
      )}
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code} title={lang.label}>
          {lang.flag} {lang.code.toUpperCase()}
        </option>
      ))}
    </select>
  );
}
